var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPolonezLocationIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 60,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "svg_17a",
    width: 54,
    height: 60,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M54 .434H.414v59.132H54z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#svg_17a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EA0029",
    d: "M27.416 58.9c14.312 0 25.915-6.393 25.915-14.279S41.728 30.343 27.416 30.343C13.103 30.343 1.5 36.735 1.5 44.62S13.103 58.9 27.416 58.9",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA0029",
    stroke: "#EA0029",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M21.635 36.518c1.912-3.844 3.82-7.688 5.733-11.529 2.057-4.136 4.169-8.535 3.798-13.14-.177-2.209-1.001-4.456-2.684-5.905-1.091-.94-2.484-1.493-3.908-1.695-3.51-.503-7.152 1.13-9.432 3.838-2.28 2.707-3.273 6.354-3.113 9.886.16 3.531 1.404 6.953 3.162 10.021 1.761 3.069 4.027 5.82 6.444 8.524"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EA0029",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M26.235 4.564a32 32 0 0 0-2.243-1.2 10.43 10.43 0 0 0-4.282-1.041h-.032c-.83-.02-1.66.121-2.428.436a14.98 14.98 0 0 0-5.521 3.931 14.74 14.74 0 0 0-3.203 6.04 8.47 8.47 0 0 0-.262 2.16c.01 1.99.334 3.97 1.016 5.839 1.674 4.59 4.445 8.767 7.462 12.694a7.016 7.016 0 0 0 2.78 2.16l2.088.903"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#EA0029",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M25.995 18.721c1.518-3.038.874-6.432-1.438-7.58s-5.417.385-6.934 3.423c-1.518 3.038-.875 6.432 1.437 7.58s5.417-.384 6.935-3.423Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EA0029",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M22.237 10.765c.877 1.582.868 3.873-.188 5.993-1.082 2.163-2.965 3.563-4.799 3.774"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#EA0029",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m21.69 36.365-3.755-1.455-5.095 5.99-10.784 2.105 17.698 10.441 10.781-2.325 7.628-7.925 7.113-.272 7.184-8.292-17.797-10.351-7.27 8.277-3.537-.2-2.167 4.007Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EA0029",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m12.92 40.914 17.568 10.204M22.977 34.03l15.264 9.163M27.454 32.518l17.808 10.377"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPolonezLocationIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/polonez-location-icon.2987834ee9a907585fba9c141a38f0d2.svg";